import {Pipe, PipeTransform} from "@angular/core";
import {SalesState} from "@portal/api/enums/sales-state";

@Pipe({ name: 'salesStateName' })

export class SalesStatePipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case SalesState.Refused:
                return 'Recusado';
            case SalesState.Analyzing:
                return 'A analizar';
            case SalesState.Deal:
                return 'Acordado';
            case SalesState.ToContact:
                return 'A contactar';
            case SalesState.ContactedViaEmail:
                return 'Contactado via email';
            case SalesState.ContactedViaSocialMedia:
                return 'Contactado via redes sociais';
            case SalesState.Contacted:
                return 'Contactado';
            case SalesState.WaitingMeeting:
                return 'A aguardar reunião';
            default:
                return 'Estado Desconhecido';
        }
    }
}
